import React from "react";
import { Card, Row, Col, Typography } from "antd";
import { roundToThreeDecimals } from "../../utils/roundToThreeDecimals";

const { Title, Text } = Typography;

interface CashboxesStatsProps {
  data: {
    _id: string;
    name: string;
    balance: number;
  }[];
  loading: boolean;
}

export default function CashboxesStats({ data, loading }: CashboxesStatsProps) {
  if (!data || data.length === 0) {
    return <div>No cashboxes available</div>;
  }

  return (
    <div style={{ padding: "20px" }}>
      <Title level={2}>Статистика Касс</Title>
      <Row gutter={12}>
        {data.map((cashbox) => (
          <Col span={4} key={cashbox._id}>
            <Card
              bordered={false}
              style={{ borderRadius: "8px", marginBottom: "16px" }}
            >
              <Title level={4}>{cashbox.name}</Title>
              <Text strong>Баланс: </Text>
              <Text>{roundToThreeDecimals(cashbox.balance)}</Text>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
}
